import { parseDateKey } from '@/components/ui/date-picker-utils';
import type { TimesheetOvertimeInput } from '../types';

const minutes = (time: string) => {
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return null;
  const [hour, minute] = time.split(':').map(Number) as [number, number];
  return hour * 60 + minute;
};

export const overtimeDuration = (start: string, end: string): number | null => {
  const from = minutes(start),
    to = minutes(end);
  if (from === null || to === null || from === to) return null;
  return to > from ? to - from : to + 1440 - from;
};

// Minutes civiles UTC : aucun décalage d'heure d'été dans les horaires déclarés.
const interval = (entry: TimesheetOvertimeInput) => {
  const start = Date.parse(`${entry.date}T00:00:00Z`) / 60_000 + (minutes(entry.startTime) ?? 0);
  return { start, end: start + (overtimeDuration(entry.startTime, entry.endTime) ?? 0) };
};

export const validateOvertime = (
  entry: TimesheetOvertimeInput,
  others: TimesheetOvertimeInput[],
  bounds: { from: string; to: string },
): string | null => {
  if (!parseDateKey(entry.date) || entry.date < bounds.from || entry.date > bounds.to)
    return 'Choisissez une date du mois comprise dans la mission.';
  if (overtimeDuration(entry.startTime, entry.endTime) === null)
    return 'Renseignez deux horaires valides et différents.';
  if (entry.endTime < entry.startTime && entry.date === bounds.to)
    return 'Cette plage dépasse la période du CRA. Déclarez une plage comprise dans cette période.';
  if (entry.surchargeRate && !/^[1-9](\.\d{1,2})?$/.test(entry.surchargeRate))
    return 'Le coefficient doit être compris entre 1 et 9,99, avec deux décimales au maximum.';
  if (others.length >= 60) return 'Le maximum de 60 plages horaires est atteint pour ce mois.';
  const current = interval(entry);
  if (
    others.some((other) => {
      const existing = interval(other);
      return current.start < existing.end && current.end > existing.start;
    })
  )
    return 'Ces horaires chevauchent une plage déjà déclarée.';
  return null;
};
